import { useEffect } from 'react';
import GATracking, { EVENT_ACTION } from '.';

interface GaLoadHOCProps {
  category: string;
  action?: string;
  label?: string;
  children: JSX.Element;
}

const GaLoadHOC = ({
  category,
  label = 'chargement de la page',
  action = EVENT_ACTION.LOAD,
  children,
}: GaLoadHOCProps) => {
  useEffect(() => {
    GATracking.init();
    GATracking.event(category, action, label);
  }, [action, category, label]);
  return children;
};

export default GaLoadHOC;
